import cn from 'classnames';
import { ComponentRef, forwardRef } from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import type { TabsListProps } from '@/shared/ui/core/tabs/model/tabs.types';
import styles from '@/shared/ui/core/tabs/ui/tabs.module.scss';


export const TabsList = forwardRef<
    ComponentRef<typeof TabsPrimitive.List>,
    TabsListProps
>(function TabsList ({
    className,
    ...props
}, ref) {
    return (
        <TabsPrimitive.List
            ref={ ref }
            className={ cn(styles.list, className) }
            { ...props }
        />
    );
});
